const aboutTabItem=[
    {
      title:"Company Story",
      eventKey:"companyStory"
    },
    {
      title:"About Our Founder",
      eventKey:"aboutOurFounder"
    },
    {
      title:"Mission Vision",
      eventKey:"missionVision"
    },
    {
      title:"Contact Us",
      eventKey:"contactUs"
    },
  
  ]

  export default aboutTabItem;